module.exports = __webpack_public_path__ + "static/media/pic.55dd63a8.png";